import { createContext, useState } from "react";
import { useDispatch } from "react-redux";

import {
  getBackUpService,
  getBackUpsService,
} from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import { toastErrorMessage } from "../../../utils/toastMessage/toastMessage";

export const backUpAdminContext = createContext({
  backUps: [],
  setBackUps: () => {},
  handleGetBackUps: () => {},
  handleGetBackUp: () => {},
});

const BackUpAdminContext = ({ children }) => {
  // Redux Dispatch
  const dispatch = useDispatch();

  const [backUps, setBackUps] = useState([]);

  // Handle Get Back Ups Method
  const handleGetBackUps = async (event) => {
    event?.preventDefault();

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getBackUpsService();
      if (status === 200) {
        setBackUps(data.files);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get Back Up Method
  const handleGetBackUp = async (name) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getBackUpService(name);
      if (status === 200 || status === 204) {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", name);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <backUpAdminContext.Provider
      value={{
        backUps,
        setBackUps,
        handleGetBackUps,
        handleGetBackUp,
      }}
    >
      {children}
    </backUpAdminContext.Provider>
  );
};

export default BackUpAdminContext;
